import React, { Component } from "react";

import { Field, reduxForm, formValueSelector } from "redux-form";
import styles from "./styles.scss";
import { connect } from "react-redux";
import * as router from "react-router-redux";
import { actions } from "./redux";
import SignUp from "../SignUp/SignUp";
import { Button, CircularProgress, Modal, Card, CardContent, TextField, FormHelperText } from "@material-ui/core";
import toast from "../../components/Toast/Toast";
import CSSModules from "react-css-modules";
import logo from "../../assets/avani-black-logo.png";
import config from '../../boot/config';
import { tooltip } from "../../utils";
import ssoSvg from '../../assets/ms-symbollockup_signin_light.svg';

@CSSModules(styles, { allowMultiple: true })
class RenderInput extends Component {
   render() {
      let {
         input,
         label,
         placeholder,
         type,
         meta: { touched, error },
         classes,
         ...other
      } = this.props;
      return (
         <div>
            <div styleName="inputWrap">
               <TextField label={label} error={touched && error} {...input} type={other.secure ? "password" : "text"} />
            </div>
            {touched && error && <FormHelperText error={touched && error}>{error}</FormHelperText>}
         </div>
      );
   }
}

@CSSModules(styles, { allowMultiple: true })
class LoginForm extends Component {
   login(data) {
      if (this.props.valid) {
         this.props.login(data.username, data.password);
      } else {
         toast("error", "Enter Valid Username & Password!");
      }
   }

	urlEncode(str) {
		let result = str.replaceAll(':','%3A').replaceAll('/','%2F').replace(' ','%20');
		return result;
	}

	loginAD() {
		let scope = this.urlEncode(config.ssoGraphScopes);
		let clientId = this.urlEncode(config.ssoClientId);
		let redirectUri = this.urlEncode(config.ssoRedirectUri);
		let nonce = tooltip.uuidv4();

		let url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize` +
			`?client_id=${clientId}` +
			`&response_type=id_token` +
			`&redirect_uri=${redirectUri}` +
			`&response_mode=fragment` +
			`&scope=${scope}` +
			`&nonce=${nonce}` +
			`&prompt=select_account`;

		window.location.href = url;
	}

   render() {
      const { handleSubmit } = this.props;
      const hasADLogin = config.ssoClientId != undefined && config.ssoClientId != null && config.ssoClientId != '';
      const localUrl = localStorage.getItem('redi-msal');
      if(localUrl != undefined && localUrl != null && localUrl != '') {
         console.log("UH HUH!", localUrl);
         this.props.loginAD(localUrl);
         localStorage.removeItem('redi-msal');
      }

      return (
         <div styleName="content">
            {(!this.props.loaded || this.props.isBusy) && <CircularProgress />}
            {this.props.loaded &&
               !this.props.isBusy && (
                  <div styleName="card">
                     <form name="meform">
                        <img styleName="logo" src={logo} />
                        <Field name="username" component={RenderInput} label="Username" />
                        <Field name="password" component={RenderInput} label="Password" secure />
                        <Button styleName="loginButton" onClick={handleSubmit(data => this.login(data))} type="submit">
                           Login
                        </Button>
                        {
                           hasADLogin &&
                           <div styleName="ssoLoginButtonContainer" onClick={() => this.loginAD()}>
                              <img src={ssoSvg} styleName="ssoLoginButton" />
                           </div>
                        }
                     </form>
                  </div>
               )}
         </div>
      );
   }
}

const Login = reduxForm({
   form: "login",
   enableReinitialize: true,
   validate: v => {
      const errors = {};
      if (!v.resetUsername) {
         if (!v.username) {
            errors.username = "Required";
         }

         if (!v.password) {
            errors.password = "Required";
         }
      }
      return errors;
   }
})(LoginForm);

const formSelector = formValueSelector("login");

const bindAction = dispatch => {
   return {
      loginAD: (token) => dispatch(actions.loginAD(token)),
      login: (user, pass) => dispatch(actions.login(user, pass)),
      logout: () => dispatch(actions.logout()),
      toggleKeepLoggedIn: () => dispatch(actions.toggleKeepLoggedIn()),
      toggleForgotPass: () => dispatch(actions.toggleForgotPass()),
      resetPass: username => dispatch(actions.resetPass(username)),

      navigate: (uri, data) => dispatch(router.push(uri, data))
   };
};

const mapStateToProps = state => ({
   initialValues: { username: state.signup.userName },
   isLoggedIn: state.login.isLoggedIn,
   currentUsername: state.login.currentUsername,
   currentScreen: state.login.currentScreen,
   loginFailReason: state.login.loginFailReason,
   keepLoggedIn: state.login.keepLoggedIn,
   showForgotPass: state.login.showForgotPass,
   resetPassSuccess: state.login.resetPassSuccess,
   loaded: state.login.loaded,

   isBusy: state.login.isBusy,
   errors: state.login.errors,
   hasError: state.login.hasError
});

export default connect(
   mapStateToProps,
   bindAction
)(Login);



// WEBPACK FOOTER //
// ./src/ui/Login/Login.js